import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";

import { useStyles } from "./ResultFilterForm.css";
import { years } from "../../../../Components/Data/Session";

class ResultFilterForm extends Component {
  render() {
    const { classes, examType, data, handleChange } = this.props;
    return (
      <div className={classes.fieldStyle}>
        <TextField
          name="year"
          select
          required
          fullWidth
          label="Session"
          variant="outlined"
          margin="normal"
          placeholder="Session"
          SelectProps={{ native: true }}
          style={{ marginRight: 10 }}
          InputProps={{
            classes: {
              notchedOutline: classes.notchedOutline,
              focused: classes.focused,
            },
          }}
          InputLabelProps={{
            classes: {
              root: classes.labelRoot,
              focused: classes.labelFocused,
            },
            shrink: true,
          }}
          value={data.year}
          onChange={handleChange}
        >
          <option value="">Select Any Year</option>
          {years.map((year, index) => (
            <option key={index} value={year}>
              {year}
            </option>
          ))}
        </TextField>
        <TextField
          name="examination"
          select
          required
          fullWidth
          label="Examination"
          variant="outlined"
          margin="normal"
          placeholder="Session"
          SelectProps={{ native: true }}
          InputProps={{
            classes: {
              notchedOutline: classes.notchedOutline,
              focused: classes.focused,
            },
          }}
          InputLabelProps={{
            classes: {
              root: classes.labelRoot,
              focused: classes.labelFocused,
            },
            shrink: true,
          }}
          value={data.examination}
          onChange={handleChange}
        >
          <option value="">Select Any One</option>
          {examType.map((exam, index) => (
            <option key={index} value={exam}>
              {exam}
            </option>
          ))}
        </TextField>
      </div>
    );
  }
}

export default withStyles(useStyles)(ResultFilterForm);
